import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

const CommonClass = twMerge(['relative', 'top-1/4', 'left-1/3', 'w-full']);

export const modalVariants = cva(CommonClass, {
  variants: {
    variant: {
      xs: 'top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 max-w-xs max-h-full',
      md: 'top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 max-w-md max-h-full',
      md456:
        'top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 max-w-[456px] max-h-full',
      xl: 'top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 max-w-xl max-h-full',
      xxl: 'top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 max-w-2xl min-h-[50vh]'
    }
  },
  defaultVariants: {
    variant: 'md'
  }
});

export const modalHeaderVariant = cva('text-emerge-navy', {
  variants: {
    headerVariant: {
      base: 'text-base font-semibold',
      lg: 'text-lg font-normal',
      xxl: 'text-2xl font-normal',
      'xxl-medium': 'text-2xl font-medium'
    }
  },
  defaultVariants: {
    headerVariant: 'xxl'
  }
});
